import { ApplicationState } from '@redux/types';
import { Contacts } from '@t/contacts';

export const getContacts = (state: ApplicationState): Contacts =>
    state.contacts;
